import Button from '@mui/material/Button';
import { makeStyles } from 'utils/styles';
import Dialog from 'components/Dialog';
import RadioGroup from 'components/RadioGroup';
import { updateAdminAccount } from 'ducks/auth';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import theme from 'source/theme';
import { currentAccount } from 'selectors/currentUser';

const useStyles = makeStyles({
  select1st: {
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  },
  select2nd: {
    color: theme.palette.background.light,
    fontWeight: 'bold'
  }
});


const Component = props => {
  const { accounts, currentAccount } = props;
  const { updateAdminAccount } = props;
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [tempAccountId, setTempAccountId] = useState(currentAccount.id);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const handleConfirm = () => {
    updateAdminAccount(tempAccountId);
    setOpen(false);
  };

  // The id comes back, not the name. It used to be the position in the list -
  // `accounts.data[accountsList.indexOf(name)]` - which was true only while the
  // list was in the order the API sent it. Sorting it below would have left a
  // tidy list that switches to the wrong customer, silently. Matching on the
  // name instead would work today and depend on names staying unique, which is
  // a constraint on a column rather than a property of the choice. The id is
  // what is being chosen and what the API is asked to switch to, so that is
  // what travels.
  const handleAccountChange = accountId => setTempAccountId(Number(accountId));

  // Alphabetical, and by the locale's rules rather than by character codes: a
  // plain sort() orders uppercase before lowercase, which would file Gestamp,
  // Mafratintas and Sultintas after every shouted name in the list.
  const accountsList = accounts.data
    .map(a => ({ value: String(a.id), label: a.name }))
    .sort((a, b) => a.label.localeCompare(b.label, 'pt'));

  return (
    <div className={props.className}>
      {
        // "Do I have more than one account", not "am I a superuser". The two
        // pick out the same people today - only a superuser is sent more than
        // one - but this is the question the button actually means, and it is
        // answered by the data rather than asserted by a flag.
        accounts.data.length > 1 ?
          <React.Fragment>
            <Button variant='outlined' size='small' color='primary' onClick={handleOpen}>
              <span className={classes.select1st}>Cliente: &nbsp;</span>
              <span className={classes.select2nd}>{currentAccount.name}</span>
            </Button>
            {
              open &&
              <Dialog
                header='Seleccione organização'
                open={open}
                onClose={handleClose}
                onConfirm={handleConfirm}
              >
                <RadioGroup
                  onChange={handleAccountChange}
                  options={accountsList}
                  value={String(tempAccountId)}
                />
              </Dialog>
            }
          </React.Fragment> :
          <Button variant='outlined' size='small' color='primary'>
            <span className={classes.select1st}>Cliente: &nbsp;</span>
            <span className={classes.select2nd}>{currentAccount.name}</span>
          </Button>
      }

    </div>
  );
};

const mapStateToProps = state => ({
  accounts: state.accounts,
  // Out of the collection this component already had, instead of out of a
  // second slice fetched separately to hold the same row. `/accounts/` is
  // scoped - one account for most people, all of them for a superuser - so the
  // row is always in here.
  currentAccount: currentAccount(state)
});

const mapDispatchToProps = ({
  updateAdminAccount
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
